(() => {
'use strict';
const root = document.getElementById('home-b');
if (!root || root.dataset.ready) return;
root.dataset.ready = 'true';
const $ = (s, el = root) => el.querySelector(s), $$ = (s, el = root) => [...el.querySelectorAll(s)];
const cfg = {prices:[{id:'47906817310898',name:'Pearl White',price:'USD $599'},{id:'47581809115314',name:'Obsidian Black',price:'USD $619'}],labels:{"playSteps":"手順を再生する","pauseSteps":"手順を一時停止する","paused":"一時停止中: ","loading":"読み込み中: ","playing":"再生中: ","audioError":"再生できません。タップしてもう一度お試しください。","playAgain":"タップしてもう一度再生","tapChord":"コードをタップしてください","fold":"折りたたむ","unfold":"広げる","showMore":"ストーリーをさらに{n}件表示","sending":"送信中…","subscribe":"最新情報を受け取る","emailError":"有効なメールアドレスを入力してください。","signupSuccess":"登録が完了しました。ご登録ありがとうございます。","signupError":"メールアドレスを保存できませんでした。もう一度お試しください。","verification":"登録を完了するには、認証を完了してください。"}};
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const mobile = matchMedia('(max-width: 760px)');
const txt = (key, fallback) => cfg.labels?.[key] || fallback;
const visible = new Set();
const safePlay = video => { if(document.querySelector('dialog[open]') && !video.closest('dialog[open]')) return; const p = video.play(); if (p) p.catch(() => {}); };
const loadPoster = v => { if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster; };
const loadVideo = v => { loadPoster(v); if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); } };
let observer;
const observe = (el, fn, threshold = .15) => { if (!el) return; el._hbVisible = fn; el._hbThreshold = threshold; observer.observe(el); };
observer = new IntersectionObserver(entries => entries.forEach(({target, isIntersecting, intersectionRatio}) => {
isIntersecting = isIntersecting && intersectionRatio >= target._hbThreshold;
isIntersecting ? visible.add(target) : visible.delete(target);
target._hbVisible?.(isIntersecting);
}), {threshold: [.15,.3,.4]});
$$('video:not(.hb-step-media video):not(.pb video)').forEach(v => observe(v, yes => {
if (yes) loadPoster(v);
if (yes && !reduced.matches && !document.hidden) { loadVideo(v); safePlay(v); } else v.pause();
}));
observe($('.hb-fold-media'), yes => { if (yes) $$('image[data-href]').forEach(el => { el.setAttribute('href', el.dataset.href); delete el.dataset.href; }); });
$$('[role="tablist"]').filter(list => !list.closest('.pb')).forEach(list => list.addEventListener('keydown', e => {
const tabs = $$('[role="tab"]', list), i = tabs.indexOf(document.activeElement);
if (i < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(e.key)) return;
e.preventDefault();
const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (/Right|Down/.test(e.key) ? 1 : -1) + tabs.length) % tabs.length;
tabs[n].focus(); tabs[n].click();
}));
function activateTabs(attribute, value) {
$$(`[${attribute}]`).forEach(b => {
const yes = b.getAttribute(attribute) === String(value);
b.setAttribute('aria-selected', yes); b.tabIndex = yes ? 0 : -1;
const panel = document.getElementById(b.getAttribute('aria-controls'));
if (panel) panel.hidden = !yes;
});
}
const painCards = $$('.hb-pain-card');
painCards.forEach((card,i) => observe(card, yes => { if (yes) { card.style.setProperty('--delay', `${i * 60}ms`); card.classList.add('is-entered'); observer.unobserve(card); } }, .3));
function flip(card, yes) {
card.setAttribute('aria-expanded', yes);
$('.hb-problem', card).hidden = yes; $('.hb-fix', card).hidden = !yes;
}
painCards.forEach(card => card.addEventListener('click', () => {
flip(card, card.getAttribute('aria-expanded') !== 'true');
$$('[data-all-fixes]').forEach(b => b.setAttribute('aria-pressed', painCards.every(c => c.getAttribute('aria-expanded') === b.dataset.allFixes)));
}));
$$('[data-all-fixes]').forEach(b => b.addEventListener('click', () => {
painCards.forEach(c => flip(c, b.dataset.allFixes === 'true'));
$$('[data-all-fixes]').forEach(el => el.setAttribute('aria-pressed', el === b));
}));
const painTrack = $('.hb-pain-track'), dots = $$('[data-pain-dot]');
let painFrame;
painTrack.addEventListener('scroll', () => {
if (painFrame) return;
painFrame = requestAnimationFrame(() => {
painFrame = 0;
const left = painTrack.getBoundingClientRect().left;
let nearest = 0, distance = Infinity;
painCards.forEach((c, i) => { const d = Math.abs(c.getBoundingClientRect().left - left); if (d < distance) { distance = d; nearest = i; } });
dots.forEach((b, i) => b.setAttribute('aria-pressed', i === nearest));
});
}, {passive:true});
dots.forEach((b, i) => b.addEventListener('click', () => painTrack.scrollTo({left: painTrack.scrollLeft + painCards[i].getBoundingClientRect().left - painTrack.getBoundingClientRect().left, behavior: reduced.matches ? 'instant' : 'smooth'})));
const stepVideos = $$('.hb-step-media video'), stepBars = $$('.hb-step-bars i');
let step = 0, manualStep = false, stepsPaused = reduced.matches, stepsVisible = false;
const stepPause = $('[data-step-pause]');
const syncSteps = () => {
stepVideos.forEach((v, i) => {
v.loop = manualStep && i === step;
if (i === step && stepsVisible) loadPoster(v);
if (i === step && stepsVisible && !stepsPaused && !document.hidden) { loadVideo(v); safePlay(v); } else v.pause();
});
stepPause.textContent = stepsPaused ? txt('playSteps','Play steps') : txt('pauseSteps','Pause steps');
stepPause.setAttribute('aria-pressed', stepsPaused);
};
function selectStep(n, manual) {
step = n; manualStep = manual;
activateTabs('data-step', n);
stepBars.forEach((bar,i) => bar.style.transform = `scaleX(${i < n ? 1 : 0})`);
const v = stepVideos[n]; if (v.readyState) v.currentTime = 0;
syncSteps();
}
$$('[data-step]').forEach(b => b.addEventListener('click', () => selectStep(Number(b.dataset.step), true)));
stepVideos.forEach((v, i) => {
v.addEventListener('timeupdate', () => { if (i === step) stepBars[i].style.transform = `scaleX(${v.duration ? v.currentTime / v.duration : 0})`; });
v.addEventListener('ended', () => { if (!manualStep) selectStep((step + 1) % 3, false); });
v.addEventListener('error', () => { v.controls = true; });
});
stepPause.addEventListener('click', () => { stepsPaused = !stepsPaused; syncSteps(); });
observe($('#film'), yes => { stepsVisible = yes; syncSteps(); });
const audio = new Audio(); audio.preload = 'none';
let audioButton = null, request = 0;
function audioState(playing, message) {
['.hb-chord-status','.hb-sound-status'].forEach(sel => {
const el = $(sel), isOwn = !!audioButton && el.closest('section') === audioButton.closest('section');
el.classList.toggle('is-playing', playing && isOwn);
if (message && isOwn) $('span:last-child', el).textContent = message;
});
}
function stopAudio() { request++; audio.pause(); audio.currentTime = 0; audioState(false); }
async function playAudio(button) {
if (button === audioButton && !audio.paused) { stopAudio(); audioState(false, txt('paused','Paused: ') + (button.dataset.chord || button.dataset.sound)); return; }
stopAudio(); audioButton = button;
const sample = button.dataset.chord || button.dataset.sound;
const selection = button.hasAttribute('data-chord') ? '[data-chord]' : '[data-sound]';
$$(selection).forEach(b => b.setAttribute('aria-pressed', b === button));
audio.src = button.dataset.audio;
if (button.dataset.chord) $('.hb-chord-status').style.setProperty('--accent', button.style.getPropertyValue('--accent'));
const token = ++request;
audioState(false, txt('loading','Loading: ') + sample);
try { await audio.play(); if (token === request) audioState(true, txt('playing','Now playing: ') + sample); }
catch { if (token === request) audioState(false, txt('audioError','Unable to play. Tap to try again.')); }
}
$$('[data-chord],[data-sound]').forEach(b => b.addEventListener('click', () => playAudio(b)));
audio.addEventListener('ended', () => audioState(false, txt('playAgain','Tap to play again.')));
audio.addEventListener('error', () => audioState(false, txt('audioError','Unable to play. Tap to try again.')));
[$('#chords'), $('#sound-design')].forEach(el => observe(el, yes => { if (!yes && audioButton?.closest('section') === el) stopAudio(); }));
$$('[data-layout]').forEach(b => b.addEventListener('click', () => {
stopAudio();
$$('[data-layout]').forEach(el => el.setAttribute('aria-pressed', el === b));
$$('[data-keys]').forEach(el => el.hidden = el.dataset.keys !== b.dataset.layout);
$('.hb-middle-note').hidden = b.dataset.layout !== '21';
$('.hb-chord-status span:last-child').textContent = txt('tapChord','Tap a chord');
}));
$('[data-fold]').addEventListener('click', e => {
const b = e.currentTarget, folded = b.getAttribute('aria-pressed') !== 'true';
b.setAttribute('aria-pressed', folded); b.textContent = folded ? txt('unfold','Unfold it') : txt('fold','Fold it');
$$('.hb-fold-svg').forEach((s, i) => {
  s.toggleAttribute('hidden', i !== Number(folded));
  s.querySelectorAll('image[data-href]').forEach(image => {
    image.setAttribute('href', image.dataset.href);
    delete image.dataset.href;
  });
});
});
['data-app','data-press'].forEach(attr => $$(`[${attr}]`).forEach(b => b.addEventListener('click', () => activateTabs(attr, b.getAttribute(attr)))));
observe($('.hb-ks'), yes => { if (yes) {
observer.unobserve($('.hb-ks'));
if (!reduced.matches) $$('.hb-ks-number i').forEach((digit, i) => {
const count = [14,17,21][i], end = [4,6,1][i]; let tick = 0;
const timer = setInterval(() => {
digit.textContent = String((end - count + ++tick + 30) % 10);
digit.classList.remove('is-flipping'); requestAnimationFrame(() => digit.classList.add('is-flipping'));
if (tick >= count || reduced.matches) { clearInterval(timer); digit.textContent = end; digit.classList.remove('is-flipping'); }
}, 75);
});
} }, .4);
let filter = 'all', expanded = false;
const storyCards = $$('.hb-story'), showStories = $('[data-show-stories]');
function filterStories() {
const matches = storyCards.filter(c => filter === 'all' || c.dataset.kind === filter);
storyCards.forEach(c => c.hidden = !matches.includes(c) || (!expanded && matches.indexOf(c) >= 6));
showStories.hidden = expanded || matches.length <= 6;
showStories.textContent = txt('showMore','Show {n} more stories').replace('{n}', matches.length - 6);
$('[data-story-count]').textContent = `${Math.min(matches.length, expanded ? matches.length : 6)} / ${matches.length}`;
}
$$('[data-filter]').forEach(b => b.addEventListener('click', () => {
filter = b.dataset.filter; expanded = false;
$$('[data-filter]').forEach(el => el.setAttribute('aria-pressed', el === b));
filterStories(); $('.hb-story-track').scrollLeft = 0;
}));
showStories.addEventListener('click', () => { expanded = true; filterStories(); });
$$('[data-faq-category]').forEach(b => b.addEventListener('click', () => {
activateTabs('data-faq-category', b.dataset.faqCategory);
$$('.hb-faq-groups details').forEach(d => d.open = false);
const first = $(`#faq-category-${b.dataset.faqCategory} details`); if (first) first.open = true;
}));
const firstFAQ = $('.hb-faq-groups details'); if (firstFAQ) firstFAQ.open = true;
const form = $('#home-b-newsletter'), email = $('#hb-email'), signupMessage = $('#hb-newsletter-message');
form.noValidate = true;
email.addEventListener('input', () => email.removeAttribute('aria-invalid'));
form.addEventListener('submit', async e => {
e.preventDefault();
if (!email.validity.valid || !email.value.trim()) {
email.setAttribute('aria-invalid', 'true'); signupMessage.textContent = txt('emailError','Please enter a valid email address.'); email.focus(); return;
}
const submit = $('button[type="submit"]', form);
if (submit.disabled) return;
submit.disabled = true; submit.textContent = txt('sending','Sending…');
try {
const response = await fetch(form.action, {method:'POST', body:new FormData(form), credentials:'same-origin', headers:{'Accept':'text/html'}});
if (!response.ok) throw new Error('request');
const url = new URL(response.url), doc = new DOMParser().parseFromString(await response.text(), 'text/html');
if (url.pathname.includes('/challenge') || doc.querySelector('form[action*="challenge"]')) {
signupMessage.textContent = txt('verification','Complete the verification to finish signing up.');
HTMLFormElement.prototype.submit.call(form); return;
}
if (doc.querySelector('[data-signup-success]') || url.searchParams.get('customer_posted') === 'true') {
$('.hb-newsletter-fields').hidden = true; signupMessage.classList.add('hb-newsletter-success'); signupMessage.textContent = txt('signupSuccess','You’re in. Thanks for signing up.');
} else {
const serverError = doc.querySelector('#home-b-newsletter .errors');
signupMessage.textContent = serverError?.textContent.trim() || txt('signupError','We couldn’t save your email. Please try again.');
}
} catch { signupMessage.textContent = txt('signupError','We couldn’t save your email. Please try again.'); }
finally { submit.disabled = false; submit.textContent = txt('subscribe','Keep me updated'); }
});
let finish = Math.max(0,cfg.prices.findIndex(p=>p.id===new URL(location.href).searchParams.get('variant')));
const variantData = JSON.parse(document.getElementById('pdp-b-data')?.textContent || '{"variants":[]}');
function setFinish(i) {
finish = cfg.prices[i] ? i : 0;
const selected = cfg.prices[finish];
const variant = variantData.variants.find(v => String(v.id) === selected.id);
const label = finish === 1 ? 'オブシディアンブラック' : 'パールホワイト';
$$('[data-finish]').forEach(b=>b.setAttribute('aria-pressed',Number(b.dataset.finish)===finish));
$$('[data-current-price]').forEach(el=>el.textContent=selected.price);
const link=$('[data-home-campaign]');
if(link)link.textContent='プロジェクトを見る · '+label;
document.dispatchEvent(new CustomEvent('jp:finish',{detail:{...selected,label,image:variant?.image}}));
}
$$('[data-finish]').forEach(b=>b.addEventListener('click',()=>setFinish(Number(b.dataset.finish))));
window.addEventListener('popstate',()=>setFinish(Math.max(0,cfg.prices.findIndex(p=>p.id===new URL(location.href).searchParams.get('variant')))));
setFinish(finish);
document.addEventListener('native:dialogchange',()=>{if(document.querySelector('dialog[open]')){stopAudio();$('video').filter(v=>!v.closest('dialog[open]')).forEach(v=>v.pause());}else{syncSteps();visible.forEach(v=>v._hbVisible?.(true));}});
document.addEventListener('visibilitychange', () => { if (document.hidden) { stopAudio(); $$('video').forEach(v => v.pause()); } else { syncSteps(); visible.forEach(v => { if (v.tagName === 'VIDEO') v._hbVisible?.(true); }); } });
reduced.addEventListener('change', () => { stepsPaused = reduced.matches; syncSteps(); $$('video').forEach(v => { if (reduced.matches) v.pause(); else if (visible.has(v)) v._hbVisible?.(true); }); });
})();
